import React from 'react';
import './App.css';
import applications from './assets/images/applications.webp';
import about from './assets/images/about.webp';
import features from './assets/images/features.webp';
import background from './assets/images/bg.webp';

const App = () => {
  return (
    <div className="app-container" style={{ backgroundImage: `url(${background})` }}>
      {/* Header Section */}
      <header className="header">
        <div className="logo">
          <h1>MightyToys.AI</h1>
        </div>
        <p className="tagline">Unleashing the Power of Play with AI</p>
      </header>

      {/* Main Content */}
      <main className="main-content">
        <section className="about-domain">
        <img src={about} alt="Mighty Toys represents the perfect fusion of cutting-edge AI technology and the playful spirit of innovation. This domain is ideal for AI-powered toy companies, smart education platforms, or robotics ventures looking for a memorable and brandable name"></img>
          <h2>Why MightyToys.AI?</h2>
          <p>
            "Mighty Toys" represents the perfect fusion of cutting-edge AI technology and the playful spirit of innovation. This domain is ideal for AI-powered toy companies, smart education platforms, or robotics ventures looking for a memorable and brandable name.
          </p>
        </section>

        <section className="use-cases">
          <img src={applications} alt="Potential Applications - AI-powered toys and interactive games, Educational tools leveraging machine learning,Robotics platforms for children and adults"></img>
          <h2>Potential Applications</h2>
          <ul>
            <li>AI-powered toys and interactive games</li>
            <li>Educational tools leveraging machine learning</li>
            <li>Robotics platforms for children and adults</li>
          </ul>
        </section>

        <section className="features">
        <img src={features} alt="Domain Features - Short and memorable name, Highly relevant in the AI and tech space, Perfect for branding and marketing."></img>
          <h2>Domain Features</h2>
          <ul>
            <li>Short and memorable name</li>
            <li>Highly relevant in the AI and tech space</li>
            <li>Perfect for branding and marketing</li>
          </ul>
        </section>
      </main>

      {/* Footer Section */}
      <footer className="footer">
        <div className="buy-domain">
          <p className="price-tag">Asking price: $1,000 USD — offers welcome</p>
          <form action="https://www.escrow.com/checkout" method="post" target="_blank">
            <input type="hidden" name="type" value="domain_name" />
            <input type="hidden" name="non_initiator_email" value="mightytoys.ai@gmail.com" />
            <input type="hidden" name="non_initiator_id" value="3880161" />
            <input type="hidden" name="non_initiator_role" value="seller" />
            <input type="hidden" name="title" value="MightyToys.ai — Premium .ai Domain Name Transfer" />
            <input type="hidden" name="currency" value="USD" />
            <input type="hidden" name="domain" value="mightytoys.ai" />
            <input type="hidden" name="price" value="1000" />
            <input type="hidden" name="concierge" value="false" />
            <input type="hidden" name="with_content" value="false" />
            <input type="hidden" name="inspection_period" value="3" />
            <input type="hidden" name="fee_payer" value="seller" />
            <input type="hidden" name="return_url" value="" />
            <input type="hidden" name="button_types" value="both" />
            <input type="hidden" name="auto_accept" value="750" />
            <input type="hidden" name="auto_reject" value="100" />
            <input type="hidden" name="item_key" value="undefined" />
            <button className="EscrowButtonSecondary" type="submit">Buy It Now</button>
            <img
              src="https://t.escrow.com/1px.gif?name=bin&price=1000&title=MightyToys.ai%20%E2%80%94%20Premium%20.ai%20Domain%20Name%20Transfer&user_id=3880161"
              style={{ display: 'none' }}
              alt=""
            />
          </form>
        </div>
        <p>Interested in MightyToys.ai? <a href="mailto:mightytoys.ai@gmail.com">Let’s talk!</a></p>

        <p className="disclaimer">MightyToys.ai is a premium domain for sale. All rights reserved.</p>
      </footer>
    </div>
  );
};

export default App;

